import Vue from 'vue'
import inform from '@/services/inform'

import { selectVariant } from './variant'

// State
const state = {
  isLoading: false,
  isSaving: false,
  data: null
}

// Mutations
export const updateVariants = 'updateVariants'
export const updateVariantInList = 'updateVariantInList'
const addVariantRequest = 'addVariantRequest'
const addVariantResponse = 'addVariantResponse'
const removeVariantRequest = 'removeVariantRequest'
const removeVariantResponse = 'removeVariantResponse'
export const resetVariants = 'resetVariants'

const mutations = {
  [updateVariants] (state, variants) {
    state.data = variants
  },
  [resetVariants] (state) {
    state.isLoading = false
    state.isSaving = false
    state.data = null
  },
  // Update one variant in the global list
  [updateVariantInList] (state, variant) {
    state.data = state.data.map(variantInList => {
      return variantInList.id === variant.id
        ? { ...variantInList, ...variant }
        : variantInList
    })
  },
  [addVariantRequest] (state, variant) {
    state.isSaving = true
  },
  [addVariantResponse] (state, variant) {
    // If the newly added variant is the new standard, make all other variants second class citizens
    const { isDefault } = variant
    state.data = [
      ...state.data.map(variant => ({
        ...variant,
        isDefault: isDefault ? false : variant.isDefault
      })),
      variant
    ]
    state.isSaving = false
  },
  [removeVariantRequest] (state) {
    state.isSaving = true
  },
  [removeVariantResponse] (state, variant) {
    const { id } = variant
    state.isSaving = false
    state.data = state.data.filter(variant => variant.id !== id)
    inform(`Variante erfolgreich gelöscht`)
  }
}

// Actions
export const addVariant = 'addVariant'
export const removeVariant = 'removeVariant'

const actions = {
  [addVariant] ({ state, commit, dispatch }, variant) {
    commit(addVariantRequest)
    return Vue.http
      .post(`${SERVER_URL}/variants`, variant)
      .then(({ data: variant }) => {
        commit(addVariantResponse, variant)
        dispatch(selectVariant, variant)
      })
  },
  [removeVariant] ({ state, commit, dispatch }, variant) {
    const { id } = variant
    commit(removeVariantRequest)
    return Vue.http
      .delete(`${SERVER_URL}/variants/${id}`)
      .then(({ data: id }) => {
        commit(removeVariantResponse, variant)
        dispatch(selectVariant, state.data.find(({ isDefault }) => isDefault))
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/variants.js